module.exports = __webpack_public_path__ + "static/google-play-badge-en-56833b126e829aebc5aa834b3b5ee4ba.png";